var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.839 13H10v8.852h2.839zM13 10.558c-.017-.85-.58-1.499-1.491-1.499-.913 0-1.509.648-1.509 1.5 0 .833.579 1.5 1.474 1.5h.017c.93 0 1.509-.667 1.509-1.5zM22.824 16.808c0-2.72-1.4-3.984-3.268-3.984-1.507 0-2.182.859-2.559 1.461v-1.253h-2.84c.038.83 0 8.851 0 8.851h2.84V16.94c0-.265.018-.529.093-.718.206-.529.673-1.076 1.457-1.076 1.028 0 1.438.812 1.438 2.001v4.736h2.84v-5.075z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M1 16C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"
  }))));
};

export default __webpack_public_path__ + "static/media/linkedin.35dfaca2.svg";
export { SvgLinkedin as ReactComponent };